export default __webpack_public_path__ + "c8e352b.png";